import { OrganizationKeyName } from "../../../model/Organization";
import { DeliveryProviderConfiguration } from "../models/delivery-provider-configuration";
import { httpClient } from "../../../service/http";

export const deliveryProviderConfigurationsHttp = {
  getDeliveryProviderConfigurations: async (
    organizationKeyName: OrganizationKeyName
  ) => {
    const res = await httpClient<{ data: DeliveryProviderConfiguration[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/delivery-provider-configurations`,
    });

    return res.data;
  },
};
